module.exports = __webpack_public_path__ + "assets/fonts/3e4c3923-d0a5-4f22-b711-f3a5769ca7fd.6a55cf7b.eot";